import { render, staticRenderFns } from "./article-card.vue?vue&type=template&id=f6c1a3ba&scoped=true&"
import script from "./article-card.ts?vue&type=script&lang=ts&"
export * from "./article-card.ts?vue&type=script&lang=ts&"
import style0 from "./article-card.scss?vue&type=style&index=0&id=f6c1a3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c1a3ba",
  null
  
)

export default component.exports